module.exports = new __parcel__URL__("chevron-down.52252869.svg").toString();